import { Link } from "react-router-dom";
import { categories } from "@/mocks/manga";

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {/* 品牌 */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5" aria-label="吹雪漫画网">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-foreground-950">
                <i className="ri-snowy-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">吹雪漫画网</span>
            </Link>
            <p className="mt-4 text-sm leading-6 text-foreground-600">
              专注雪景、冬日、雪国、冰雪、冬物语与雪女传说的题材漫画站，高清在线看，分类清晰，点开即读。
            </p>
            <div className="mt-4 flex items-center gap-3 text-foreground-500">
              <a href="#" aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300/70 hover:border-primary-500 hover:text-primary-500"><i className="ri-weibo-line"></i></a>
              <a href="#" aria-label="微信公众号" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300/70 hover:border-primary-500 hover:text-primary-500"><i className="ri-wechat-line"></i></a>
              <a href="#" aria-label="哔哩哔哩" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300/70 hover:border-primary-500 hover:text-primary-500"><i className="ri-bilibili-line"></i></a>
            </div>
          </div>

          {/* 题材分类 */}
          <div>
            <h3 className="font-heading text-sm font-semibold text-foreground-950">题材分类</h3>
            <ul className="mt-4 space-y-2.5">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`} className="text-sm text-foreground-600 transition-colors hover:text-primary-500">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 网站导航 */}
          <div>
            <h3 className="font-heading text-sm font-semibold text-foreground-950">网站导航</h3>
            <ul className="mt-4 space-y-2.5">
              {[
                { to: "/", label: "首页" },
                { to: "/category/xueguo", label: "雪国精选" },
                { to: "/about", label: "关于我们" },
                { to: "/faq", label: "常见问题" },
                { to: "/contact", label: "联系我们" },
              ].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-foreground-600 transition-colors hover:text-primary-500">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 联系 */}
          <div>
            <h3 className="font-heading text-sm font-semibold text-foreground-950">联系我们</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-start gap-2"><i className="ri-mail-line mt-0.5 text-primary-500"></i>hello@chuixue-manga.example.com</li>
              <li className="flex items-start gap-2"><i className="ri-time-line mt-0.5 text-primary-500"></i>投稿与商务合作：欢迎来信</li>
              <li className="flex items-start gap-2"><i className="ri-question-line mt-0.5 text-primary-500"></i>阅读问题：可前往常见问题查看</li>
            </ul>
            <Link
              to="/contact"
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-4 py-2 text-sm font-medium text-background-950 transition-colors hover:bg-secondary-600"
            >
              联系我们
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200/70 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © {new Date().getFullYear()} 吹雪漫画网 版权所有 · 冬日题材漫画在线阅读
          </p>
          <p className="text-xs text-foreground-600">
            本站内容仅供学习交流，请在阅读前确认当地相关规定。
          </p>
        </div>
      </div>
    </footer>
  );
}